module.exports = __webpack_public_path__ + "static/img/052 2.e94318b3.jpg";